<template>
    <div id="root" class="main-container">
        <!-- 白名单视图 -->
        <template v-if="hasWhite">
            <router-view></router-view>
        </template>
        <template v-else>
            <!-- 登陆后视图 -->
            <template v-if="hasToken && hasUserName && isShowAppContent">
                <!-- 顶部应用区 -->
                <top-nav ref="topNavRef" v-if="hasShowTop" />
                <div class="main-content-wrap" :style="!hasShowTop ? { height: '100%', top: '0' } : ''">
                    <!-- 左侧菜单区-->
                    <left-menu class="main-menu-box" v-show="hasLeftMenu && leftMenuShowState" />
                    <!-- 右侧视图-->
                    <div class="main-container-content" :style="!hasLeftMenu || !leftMenuShowState ? { left: '18px' } : ''">
                        <!-- 面包屑导航区-->
                        <div class="main-container-nav" v-if="currentPath.length > 1 || !hasLeftMenu || !leftMenuShowState">
                            <div class="main-container-breadcrumb">
                                <dt-breadcrumb :currentPath="currentPath"></dt-breadcrumb>
                            </div>
                        </div>
                        <!-- 子应用渲染区 -->
                        <div class="main-container-view"
                            :style="{ minHeight: currentPath.length <= 1 && hasLeftMenu && leftMenuShowState ? '100%' : 'calc(100% - 71px)' }">
                            <!-- qiankun2.0  container 模式-->
                            <!--<div id="subapp-viewport" class="app-view-box"></div>-->
                            <!-- qiankun1.0  render 模式-->
                            <div id="root-view" class="app-view-box" v-html="content"></div>
                        </div>
                    </div>
                    <span class="left-menu-silder-btn" @click="changeLeftMenuShowState" v-if="hasLeftMenu"
                        :style="{ left: leftMenuShowState ? '238px' : '0' }">
                        <i class="left-menu-silder-icon" :class="leftMenuShowState ? 'arrow-icon-open' : 'arrow-icon-close'
                            "></i>
                    </span>
                </div>
            </template>
            <!-- 登录视图 -->
            <!-- qiankun2.0  container 模式-->
            <!--<div v-else id="subapp-viewport" class="app-view-box"></div>-->
            <!-- qiankun1.0  render 模式-->
            <div v-else id="root-view" class="app-view-box" v-html="content"></div>
        </template>
        <!--&lt;!&ndash;版本更新提示框&ndash;&gt;-->
        <!--<version-update-->
        <!--:formVisible="showUpdate"-->
        <!--@close-update-box="closeUpdateBox"-->
        <!--&gt;</version-update>-->
        <!-- <edit-password ref="editPassword" v-if="weakPassword" :editModalVisible="weakPassword"></edit-password> -->
        <code-login ref="codeLogin" v-if="isShowCodeLogin" :editModalVisible="isShowCodeLogin"></code-login>
    </div>
</template>

<script>
import { mapGetters } from "vuex"; // 引入状态共享
import LeftMenu from "@/components/LeftMenu.vue";
import TopNav from "@/components/TopNav.vue";
import VersionUpdate from "@/components/VersionUpdate.vue";
import editPassword from "@/components/EditPassword.vue";
import CodeLogin from "@/components/CodeLogin.vue";
import { getToken } from "@/library/js/auth.js";
import { valInDeep } from "@/library/js/array.js";
import Cookies from 'js-cookie';

/**
 * @name 导入白名单路由集合
 */
const whiteList = ["/freelogin", "/thirdoauth"];

export default {
    name: "rootView",
    props: {
        loading: Boolean,
        content: String,
    },
    components: {
        LeftMenu,
        TopNav,
        VersionUpdate,
        editPassword,
        CodeLogin
    },
    data() {
        return {
            appViewStyle: {
                height: ""
            },
        };
    },
    computed: {
        // 导入vuex菜单数据，菜单折叠状态
        ...mapGetters(["menus", "currentPath", "leftMenuShowState", "weakPassword", "isCodeLogin"]),
        hasToken() {
            return !!ssoClient.getCookie() || !!getToken();
        },
        hasUserName() {
            return !!this.$store.getters.userName;
        },
        isShowAppContent() {
            if (this.$route.path === "/outside/login") {
                return false;
            }
            return true;
        },
        isShowCodeLogin() {
            console.log(Cookies.get('codeLoginState') != 1)
            console.log(this.$store.getters.isCodeLogin)
            console.log(this.$store.getters.mobile)
            return Cookies.get('codeLoginState') != 1 && this.$store.getters.isCodeLogin
        },
        hasLeftMenu() {
            let isHas = true;
            if (this.menus.length > 0) {
                if (this.menus.length == 1 && this.menus[0].children.length == 0) {
                    isHas = false;
                }
            }
            if (this.$store.getters.runtimeEnvir === "screen") {
                isHas = false;
            }
            return isHas;
        },
        hasShowTop() {
            return !(this.$store.getters.runtimeEnvir === "screen");
        },
        hasWhite() {
            let isHasWhite = false;
            if (whiteList.indexOf(this.$route.path) !== -1) {
                isHasWhite = true;
            }
            return isHasWhite;
        },
        // hasFromTencent () {
        //     return this.$route.path.indexOf("tencentclass") > -1;
        // }
    },
    watch: {
        $route(to, from) {
            let _this = this;
            this.path = to.path;
            //从树形菜单中递归筛选当前路由地址的菜单
            let targetMenu = valInDeep(this.menus, this.path, "path", "children");
            if (targetMenu.length > 0) {
                if (targetMenu[0].children.length > 0) {
                    _this.$store.dispatch(
                        "menu/setSelectedMenuId",
                        targetMenu[0].children[0].id
                    );
                } else {
                    _this.$store.dispatch("menu/setSelectedMenuId", targetMenu[0].id);
                }
                //设置头部面包屑导航
                this.$util.setCurrentPath(this, this.path, this.$route.params);
            }
            if (this.$refs.topNavRef) {
                //切换菜单时隐藏顶部更多应用框
                this.$refs.topNavRef.handleCloseMoreBox();
            }
        },
    },
    methods: {
        appendScreenStyle() {
            let screen_link = document.createElement("link");
            screen_link.setAttribute("rel", "stylesheet");
            screen_link.setAttribute("type", "text/css");
            screen_link.setAttribute("href", "/static/screenStyle/main.css");
            document.head.appendChild(screen_link);
        },
        /**
         * 改变左边菜单显示状态
         */
        changeLeftMenuShowState() {
            this.$store.commit(
                "app/SET_LEFT_MENU_SHOW_STATE",
                !this.leftMenuShowState
            );
        }
    },
    mounted() {
        if (window.cef != undefined) {
            this.$store.commit("app/SET_RUNTIMEENVIR", "screen");
            this.appendScreenStyle();
        }
    }
};
</script>

<style lang="scss">
@import "./style/mixins";

html,
body {
    margin: 0;
    padding: 0;
    height: 100%;
    font-family: Microsoft YaHei;
    min-width: 1366px;
    overflow-x: auto;
}

.main-container {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: auto;
}

.main-content-wrap {
    position: absolute;
    top: 60px;
    right: 0;
    left: 0;
    bottom: 0;
    padding: 18px 18px;
    background: #fafafa;
    display: flex;
    width: 100%;
    height: auto;
    overflow: hidden;
}

.main-container-content {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 257px;
    padding: 18px 18px 18px 0;
    overflow-y: auto;
    overflow-x: hidden;
    z-index: 999;

    >.main-container-nav {
        background: $main-white;
        height: 51px;
        line-height: 51px;
        margin-bottom: 20px;
        border-radius: 10px;
        padding-left: 43px;
    }

    >.main-container-view {
        min-height: calc(100% - 71px);
        /*min-width: 1366px;*/
        box-sizing: border-box;
        background: $main-white;
        border-radius: 10px;
        padding: 8px 20px;

        >.wl-scroll {
            width: 100%;
            height: 100%;
            background: $main-white;
            border-radius: 4px;

            .el-scrollbar__wrap {
                overflow-x: hidden;
            }
        }
    }
}

.left-menu-silder-btn {
    height: 64px;
    position: absolute;
    top: calc(50% - 32px);
    left: 238px;
    line-height: 46px;
    cursor: pointer;
    color: rgb(191, 191, 191);
    border-width: 9px 9px 9px 20px;
    border-style: solid;
    border-color: transparent transparent transparent #efefef;
    border-image: initial;
    border-left: 18px solid #efefef;
    transition: right 0.1s ease-in-out 0s, border 0.1s ease 0s;

    .left-menu-silder-icon {
        position: absolute;
        left: -18px;
        top: 15px;
        width: 16px;
        height: 16px;
        display: block;
    }

    .arrow-icon-open {
        background: url("./assets/main/icon_arrow_left.png");
    }

    .arrow-icon-close {
        background: url("./assets/main/icon_arrow_right.png");
    }
}
</style>
